import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OverviewBehaviourAnalytics from "./routes/OverviewBehaviourAnalytics";
import CategoryBehaviourAnalytics from "./routes/CategoryBehaviourAnalytics";
import GradeBehaviourAnalytics from "./routes/GradeBehaviourAnalytics";
import StudentBehaviourAnalytics from "./routes/StudentBehaviourAnalytics";
export default store => {
  return {
    path: "behaviour",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "behaviour" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      OverviewBehaviourAnalytics(store),
      CategoryBehaviourAnalytics(store),
      GradeBehaviourAnalytics(store),
      StudentBehaviourAnalytics(store),
    ],
  };
};
